import _asyncToGenerator from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";
import { blob, greedy, seq, struct, u32, u8 } from '@solana/buffer-layout';
import { ExtensionType, getExtensionData } from '../extensionType.js';
import { PublicKey } from '@solana/web3.js';
import { bool, publicKey, u64 } from '@solana/buffer-layout-utils';
import { TokenTransferHookAccountNotFound } from '../../errors.js';
import { unpackSeeds } from './seeds.js';
/** Buffer layout for de/serializing a transfer hook extension */

export var TransferHookLayout = struct([publicKey('authority'), publicKey('programId')]);
export var TRANSFER_HOOK_SIZE = TransferHookLayout.span;
export function getTransferHook(mint) {
  var extensionData = getExtensionData(ExtensionType.TransferHook, mint.tlvData);

  if (extensionData !== null) {
    return TransferHookLayout.decode(extensionData);
  } else {
    return null;
  }
}
/** Buffer layout for de/serializing a transfer hook account extension */

export var TransferHookAccountLayout = struct([bool('transferring')]);
export var TRANSFER_HOOK_ACCOUNT_SIZE = TransferHookAccountLayout.span;
export function getTransferHookAccount(account) {
  var extensionData = getExtensionData(ExtensionType.TransferHookAccount, account.tlvData);

  if (extensionData !== null) {
    return TransferHookAccountLayout.decode(extensionData);
  } else {
    return null;
  }
}
export function getExtraAccountMetaAddress(mint, programId) {
  var seeds = [Buffer.from('extra-account-metas'), mint.toBuffer()];
  return PublicKey.findProgramAddressSync(seeds, programId)[0];
}
/** Buffer layout for de/serializing an ExtraAccountMeta */

export var ExtraAccountMetaLayout = struct([u8('discriminator'), blob(32, 'addressConfig'), bool('isSigner'), bool('isWritable')]);
/** Buffer layout for de/serializing a list of ExtraAccountMeta prefixed by a u32 length */

export var ExtraAccountMetaListLayout = struct([u32('count'), seq(ExtraAccountMetaLayout, greedy(ExtraAccountMetaLayout.span), 'extraAccounts')]);
/** Buffer layout for de/serializing an ExtraAccountMetaAccountData */

export var ExtraAccountMetaAccountDataLayout = struct([u64('instructionDiscriminator'), u32('length'), ExtraAccountMetaListLayout.replicate('extraAccountsList')]);
/** Unpack an extra account metas account and parse the data into a list of ExtraAccountMetas */

export function getExtraAccountMetas(account) {
  var extraAccountsList = ExtraAccountMetaAccountDataLayout.decode(account.data).extraAccountsList;
  return extraAccountsList.extraAccounts.slice(0, extraAccountsList.count);
}
/** Take an ExtraAccountMeta and construct that into an acutal AccountMeta */

export function resolveExtraAccountMeta(_x, _x2, _x3, _x4, _x5) {
  return _resolveExtraAccountMeta.apply(this, arguments);
}

function _resolveExtraAccountMeta() {
  _resolveExtraAccountMeta = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connection, extraMeta, previousMetas, instructionData, transferHookProgramId) {
    var programId, accountIndex, seeds, pubkey;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(extraMeta.discriminator === 0)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", {
              pubkey: new PublicKey(extraMeta.addressConfig),
              isSigner: extraMeta.isSigner,
              isWritable: extraMeta.isWritable
            });

          case 2:
            programId = PublicKey.default;

            if (!(extraMeta.discriminator === 1)) {
              _context.next = 7;
              break;
            }

            programId = transferHookProgramId;
            _context.next = 11;
            break;

          case 7:
            accountIndex = extraMeta.discriminator - (1 << 7);

            if (!(previousMetas.length <= accountIndex)) {
              _context.next = 10;
              break;
            }

            throw new TokenTransferHookAccountNotFound();

          case 10:
            programId = previousMetas[accountIndex].pubkey;

          case 11:
            _context.next = 13;
            return unpackSeeds(extraMeta.addressConfig, previousMetas, instructionData, connection);

          case 13:
            seeds = _context.sent;
            pubkey = PublicKey.findProgramAddressSync(seeds, programId)[0];
            return _context.abrupt("return", {
              pubkey: pubkey,
              isSigner: extraMeta.isSigner,
              isWritable: extraMeta.isWritable
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolveExtraAccountMeta.apply(this, arguments);
}